/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kind: NonNullable<unknown> }} Cmspost_Place_Settings1Inputs */

const vi_cmspost_place_settings1 = /** @type {(inputs: Cmspost_Place_Settings1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cài đặt website (${i?.kind})`)
};

/**

* @param {Cmspost_Place_Settings1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_place_settings1 = /** @type {((inputs: Cmspost_Place_Settings1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Place_Settings1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_place_settings1(inputs)
});
export { cmspost_place_settings1 as "cmsPost_place_settings" }